import React, { useEffect, forwardRef } from 'react';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import AnchorLink from 'react-anchor-link-smooth-scroll';

import text from '/assets/images/2022aug/footer_text.svg';
import twitter from '/assets/images/2022aug/twitter.svg';
import insta from '/assets/images/2022aug/insta.svg';
import line from '/assets/images/2022aug/line.svg';
import arrow from "/assets/images/2022aug/arrow02.svg";

import '../styles/Footer.scss'

const Footer = forwardRef((props, ref) => {

    useEffect(() => {
         // サークル回転
         const circle = document.getElementsByClassName('circle');
         gsap.to(circle, {
             rotation: 360,
             ease: "none",
             repeat: -1,
             transformOrigin: "center",
             duration: 5
         }); 

        //レイヤー表示
        const target = document.getElementsByClassName('footer__inner');
        ScrollTrigger.create({
            trigger: '.footer',
            start: 'bottom-=50 bottom',
            toggleClass: {targets: target, className: "is-active"},
            normalizeScroll: true,
            ignoreMobileResize: true
            // once: true,
            // markers: true,
        });

    },[]);

    return (
        <section className="footer" ref={ref}>
            <div className="footer__inner">
                <div className="footer__text">
                    <div className="bg"></div>
                    <a className="text" href="https://uchoobeauty.com/"><img src={text} alt="ONLINE STORE" width="194" height="234"/></a>
                </div>
                <div className="footer__sns">
                    <h4>OFFICIAL SNS</h4>
                    <ul className="footer__list">
                        <li className="footer__item insta"><a href="https://www.instagram.com/u_choo_official/" target="_blank"><img src={insta} alt="Instagram" /></a></li>
                        <li className="footer__item twitter"><a href="https://twitter.com/u_choo_official" target="_blank"><img src={twitter} alt="Twitter" /></a></li>
                        <li className="footer__item line"><a href="https://page.line.me/488vrtum?openQrModal=true" target="_blank"><img src={line} alt="LINE" /></a></li>
                    </ul>
                </div>
                <div className="footer__loop">
                    <div className="wrap">
                        <ul className="ltr">
                            <li>U/CHOO OFFICIAL ONLINE STORE</li>
                            <li>U/CHOO OFFICIAL ONLINE STORE</li>
                            <li>U/CHOO OFFICIAL ONLINE STORE</li>
                            <li>U/CHOO OFFICIAL ONLINE STORE</li>
                            <li>U/CHOO OFFICIAL ONLINE STORE</li>
                            <li>U/CHOO OFFICIAL ONLINE STORE</li>
                            <li>U/CHOO OFFICIAL ONLINE STORE</li>
                            <li>U/CHOO OFFICIAL ONLINE STORE</li>
                        </ul>
                        <ul className="rtl">
                            <li>BE BEAUTIFUL WITH U/CHOO</li>
                            <li>BE BEAUTIFUL WITH U/CHOO</li>
                            <li>BE BEAUTIFUL WITH U/CHOO</li>
                            <li>BE BEAUTIFUL WITH U/CHOO</li>
                            <li>BE BEAUTIFUL WITH U/CHOO</li>
                            <li>BE BEAUTIFUL WITH U/CHOO</li>
                            <li>BE BEAUTIFUL WITH U/CHOO</li>
                            <li>BE BEAUTIFUL WITH U/CHOO</li>
                        </ul>
                    </div>
                </div>
                <div className="footer__pageTop">
                    <AnchorLink href="#pageTop" offset={5000}>
                        <div className="circle"></div>
                        <div className="arrow"><img src={arrow} alt="PAGE TOP" /></div>
                    </AnchorLink>
                </div>
            </div>
        </section>
    )
})

export default Footer